// Shared Types
export const SHOW_SNACKBAR = 'shared/SHOW_SNACKBAR'

export const FETCH_IMAGE_TYPES_REQUEST = 'shared/FETCH_IMAGE_TYPES_REQUEST'
export const FETCH_IMAGE_TYPES_SUCCESS = 'shared/FETCH_IMAGE_TYPES_SUCCESS'
export const FETCH_IMAGE_TYPES_FAILURE = 'shared/FETCH_IMAGE_TYPES_FAILURE'

export const SEARCH_STREETS_REQUEST = 'shared/SEARCH_STREETS_REQUEST'
export const SEARCH_STREETS_SUCCESS = 'shared/SEARCH_STREETS_SUCCESS'
export const SEARCH_STREETS_FAILURE = 'shared/SEARCH_STREETS_FAILURE'

export const SEARCH_GIS_STREETS_REQUEST = 'shared/SEARCH_GIS_STREETS_REQUEST'
export const SEARCH_GIS_STREETS_SUCCESS = 'shared/SEARCH_GIS_STREETS_SUCCESS'
export const SEARCH_GIS_STREETS_FAILURE = 'shared/SEARCH_GIS_STREETS_FAILURE'

export const SEARCH_COMMUNITIES_REQUEST = 'shared/SEARCH_COMMUNITIES_EQUEST'
export const SEARCH_COMMUNITIES_SUCCESS = 'shared/SEARCH_COMMUNITIES_SUCCESS'
export const SEARCH_COMMUNITIES_FAILURE = 'shared/SEARCH_COMMUNITIES_FAILURE'

export const FETCH_FORMS_REQUEST = 'shared/FETCH_FORMS_REQUEST'
export const FETCH_FORMS_SUCCESS = 'shared/FETCH_FORMS_SUCCESS'
export const FETCH_FORMS_FAILURE = 'shared/FETCH_FORMS_FAILURE'

export const FETCH_MOBILE_USER_MODES_REQUEST =
  'shared/FETCH_MOBILE_USER_MODES_REQUEST'
export const FETCH_MOBILE_USER_MODES_SUCCESS =
  'shared/FETCH_MOBILE_USER_MODES_SUCCESS'
export const FETCH_MOBILE_USER_MODES_FAILURE =
  'shared/FETCH_MOBILE_USER_MODES_FAILURE'

export const SEARCH_CONTACT_TITLES_REQUEST =
  'shared/SEARCH_CONTACT_TITLES_REQUEST'
export const SEARCH_CONTACT_TITLES_SUCCESS =
  'shared/SEARCH_CONTACT_TITLES_SUCCESS'
export const SEARCH_CONTACT_TITLES_FAILURE =
  'shared/SEARCH_CONTACT_TITLES_FAILURE'

export const SEARCH_CONTACT_TYPES_REQUEST =
  'shared/SEARCH_CONTACT_TYPES_REQUEST'
export const SEARCH_CONTACT_TYPES_SUCCESS =
  'shared/SEARCH_CONTACT_TYPES_SUCCESS'
export const SEARCH_CONTACT_TYPES_FAILURE =
  'shared/SEARCH_CONTACT_TYPES_FAILURE'

export const SEARCH_ORGANIZATION_REQUEST = 'shared/SEARCH_ORGANIZATION_REQUEST'
export const SEARCH_ORGANIZATION_SUCCESS = 'shared/SEARCH_ORGANIZATION_SUCCESS'
export const SEARCH_ORGANIZATION_FAILURE = 'shared/SEARCH_ORGANIZATION_FAILURE'

export const SEARCH_INDUSTRY_REQUEST = 'shared/SEARCH_INDUSTRY_REQUEST'
export const SEARCH_INDUSTRY_SUCCESS = 'shared/SEARCH_INDUSTRY_SUCCESS'
export const SEARCH_INDUSTRY_FAILURE = 'shared/SEARCH_INDUSTRY_FAILURE'

export const EXPORT_LIST_DATA_REQUEST = 'shared/EXPORT_LIST_DATA_REQUEST'
export const EXPORT_LIST_DATA_SUCCESS = 'shared/EXPORT_LIST_DATA_SUCCESS'
export const EXPORT_LIST_DATA_FAILURE = 'shared/EXPORT_LIST_DATA_FAILURE'

export const SEARCH_PAYMENT_PURPOSES_REQUEST =
  'shared/SEARCH_PAYMENT_PURPOSES_REQUEST'
export const SEARCH_PAYMENT_PURPOSES_SUCCESS =
  'shared/SEARCH_PAYMENT_PURPOSES_SUCCESS'
export const SEARCH_PAYMENT_PURPOSES_FAILURE =
  'shared/SEARCH_PAYMENT_PURPOSES_FAILURE'

export const SEARCH_FINANCIAL_INSTITUTION_REQUEST =
  'shared/SEARCH_FINANCIAL_INSTITUTION_REQUEST'
export const SEARCH_FINANCIAL_INSTITUTION_SUCCESS =
  'shared/SEARCH_FINANCIAL_INSTITUTION_SUCCESS'
export const SEARCH_FINANCIAL_INSTITUTION_FAILURE =
  'shared/SEARCH_FINANCIAL_INSTITUTION_FAILURE'

export const FETCH_LOCALIZATION_REQUEST = 'shared/FETCH_LOCALIZATION_REQUEST'
export const FETCH_LOCALIZATION_SUCCESS = 'shared/FETCH_LOCALIZATION_SUCCESS'
export const FETCH_LOCALIZATION_FAILURE = 'shared/FETCH_LOCALIZATION_FAILURE'

export const FETCH_SWITCHABLE_DATA_CYCLES_REQUEST =
  'shared/FETCH_SWITCHABLE_DATA_CYCLES_REQUEST'
export const FETCH_SWITCHABLE_DATA_CYCLES_SUCCESS =
  'shared/FETCH_SWITCHABLE_DATA_CYCLES_SUCCESS'
export const FETCH_SWITCHABLE_DATA_CYCLES_FAILURE =
  'shared/FETCH_SWITCHABLE_DATA_CYCLES_FAILURE'

export const FETCH_ROUND_FACTORS_REQUEST = 'shared/FETCH_ROUND_FACTORS_REQUEST'
export const FETCH_ROUND_FACTORS_SUCCESS = 'shared/FETCH_ROUND_FACTORS_SUCCESS'
export const FETCH_ROUND_FACTORS_FAILURE = 'shared/FETCH_ROUND_FACTORS_FAILURE'

export const FETCH_AREA_ROUNDING_REQUEST = 'shared/FETCH_AREA_ROUNDING_REQUEST'
export const FETCH_AREA_ROUNDING_SUCCESS = 'shared/FETCH_AREA_ROUNDING_SUCCESS'
export const FETCH_AREA_ROUNDING_FAILURE = 'shared/FETCH_AREA_ROUNDING_FAILURE'

export const SEARCH_WARDS_REQUEST = 'shared/SEARCH_WARDS_REQUEST'
export const SEARCH_WARDS_SUCCESS = 'shared/SEARCH_WARDS_SUCCESS'
export const SEARCH_WARDS_FAILURE = 'shared/SEARCH_WARDS_FAILURE'

export const DETECT_WARD_BY_COORDINATE_REQUEST =
  'shared/DETECT_WARD_BY_COORDINATE_REQUEST'
export const DETECT_WARD_BY_COORDINATE_SUCCESS =
  'shared/DETECT_WARD_BY_COORDINATE_SUCCESS'
export const DETECT_WARD_BY_COORDINATE_FAILURE =
  'shared/DETECT_WARD_BY_COORDINATE_FAILURE'

export const FETCH_SEARCH_TYPES_REQUEST = 'shared/FETCH_SEARCH_TYPES_REQUEST'
export const FETCH_SEARCH_TYPES_SUCCESS = 'shared/FETCH_SEARCH_TYPES_SUCCESS'
export const FETCH_SEARCH_TYPES_FAILURE = 'shared/FETCH_SEARCH_TYPES_FAILURE'

export const FETCH_WARDS_REQUEST = 'shared/FETCH_WARDS_REQUEST'
export const FETCH_WARDS_SUCCESS = 'shared/FETCH_WARDS_SUCCESS'
export const FETCH_WARDS_FAILURE = 'shared/FETCH_WARDS_FAILURE'

export const FETCH_DISCOUNT_GROUPS_REQUEST =
  'shared/FETCH_DISCOUNT_GROUPS_REQUEST'
export const FETCH_DISCOUNT_GROUPS_SUCCESS =
  'shared/FETCH_DISCOUNT_GROUPS_SUCCESS'
export const FETCH_DISCOUNT_GROUPS_FAILURE =
  'shared/FETCH_DISCOUNT_GROUPS_FAILURE'

export const FETCH_ASSESSABLE_TYPES_REQUEST =
  'shared/FETCH_ASSESSABLE_TYPES_REQUEST'
export const FETCH_ASSESSABLE_TYPES_SUCCESS =
  'shared/FETCH_ASSESSABLE_TYPES_SUCCESS'
export const FETCH_ASSESSABLE_TYPES_FAILURE =
  'shared/FETCH_ASSESSABLE_TYPES_FAILURE'

export const FETCH_PROPERTY_STATUSES_REQUEST =
  'shared/FETCH_PROPERTY_STATUSES_REQUEST'
export const FETCH_PROPERTY_STATUSES_SUCCESS =
  'shared/FETCH_PROPERTY_STATUSES_SUCCESS'
export const FETCH_PROPERTY_STATUSES_FAILURE =
  'shared/FETCH_PROPERTY_STATUSES_FAILURE'

export const FETCH_ORGANIZATIONS_REQUEST = 'shared/FETCH_ORGANIZATIONS_REQUEST'
export const FETCH_ORGANIZATIONS_SUCCESS = 'shared/FETCH_ORGANIZATIONS_SUCCESS'
export const FETCH_ORGANIZATIONS_FAILURE = 'shared/FETCH_ORGANIZATIONS_FAILURE'

export const FETCH_BUSINESS_CATEGORIES_REQUEST =
  'shared/FETCH_BUSINESS_CATEGORIES_REQUEST'
export const FETCH_BUSINESS_CATEGORIES_SUCCESS =
  'shared/FETCH_BUSINESS_CATEGORIES_SUCCESS'
export const FETCH_BUSINESS_CATEGORIES_FAILURE =
  'shared/FETCH_BUSINESS_CATEGORIES_FAILURE'

export const FETCH_INACTIVITY_SETTINGS_REQUEST =
  'shared/FETCH_INACTIVITY_SETTINGS_REQUEST'
export const FETCH_INACTIVITY_SETTINGS_SUCCESS =
  'shared/FETCH_INACTIVITY_SETTINGS_SUCCESS'
export const FETCH_INACTIVITY_SETTINGS_FAILURE =
  'shared/FETCH_INACTIVITY_SETTINGS_FAILURE'

export const SET_DEFAULT_DATA = 'wards/SET_DEFAULT_DATA'

export const FETCH_BUSINESS_SUBCATEGORY_TYPE_REQUEST =
  'shared/FETCH_BUSINESS_SUBCATEGORY_TYPE_REQUEST'
export const FETCH_BUSINESS_SUBCATEGORY_TYPE_SUCCESS =
  'shared/FETCH_BUSINESS_SUBCATEGORY_TYPE_SUCCESS'
export const FETCH_BUSINESS_SUBCATEGORY_TYPE_FAILURE =
  'shared/FETCH_BUSINESS_SUBCATEGORY_TYPE_FAILURE'

export const FETCH_BUSINESS_SUBCATEGORY_CALCULATION_TYPE_REQUEST =
  'shared/FETCH_BUSINESS_SUBCATEGORY_CALCULATION_TYPE_REQUEST'
export const FETCH_BUSINESS_SUBCATEGORY_CALCULATION_TYPE_SUCCESS =
  'shared/FETCH_BUSINESS_SUBCATEGORY_CALCULATION_TYPE_SUCCESS'
export const FETCH_BUSINESS_SUBCATEGORY_CALCULATION_TYPE_FAILURE =
  'shared/FETCH_BUSINESS_SUBCATEGORY_CALCULATION_TYPE_FAILURE'

export const FETCH_CONTACTS_REQUEST = 'shared/FETCH_CONTACTS_REQUEST'
export const FETCH_CONTACTS_SUCCESS = 'shared/FETCH_CONTACTS_SUCCESS'
export const FETCH_CONTACTS_FAILURE = 'shared/FETCH_CONTACTS_FAILURE'

export const FETCH_CONTACT_TITLES_REQUEST =
  'shared/FETCH_CONTACT_TITLES_REQUEST'
export const FETCH_CONTACT_TITLES_SUCCESS =
  'shared/FETCH_CONTACT_TITLES_SUCCESS'
export const FETCH_CONTACT_TITLES_FAILURE =
  'shared/FETCH_CONTACT_TITLES_FAILURE'

export const FETCH_ACTIVE_LAYERS_REQUEST = 'shared/FETCH_ACTIVE_LAYERS_REQUEST'
export const FETCH_ACTIVE_LAYERS_SUCCESS = 'shared/FETCH_ACTIVE_LAYERS_SUCCESS'
export const FETCH_ACTIVE_LAYERS_FAILURE = 'shared/FETCH_ACTIVE_LAYERS_FAILURE'

export const DETECT_LAYER_REQUEST = 'shared/DETECT_LAYER_REQUEST'
export const DETECT_LAYER_SUCCESS = 'shared/DETECT_LAYER_SUCCESS'
export const DETECT_LAYER_FAILURE = 'shared/DETECT_LAYER_FAILURE'

export const DETECT_ALL_LAYERS_REQUEST = 'shared/DETECT_ALL_LAYERS_REQUEST'
export const DETECT_ALL_LAYERS_SUCCESS = 'shared/DETECT_ALL_LAYERS_SUCCESS'
export const DETECT_ALL_LAYERS_FAILURE = 'shared/DETECT_ALL_LAYERS_FAILURE'

export const FETCH_LAYER_FEATURES_REQUEST =
  'shared/FETCH_LAYER_FEATURES_REQUEST'
export const FETCH_LAYER_FEATURES_SUCCESS =
  'shared/FETCH_LAYER_FEATURES_SUCCESS'
export const FETCH_LAYER_FEATURES_FAILURE =
  'shared/FETCH_LAYER_FEATURES_FAILURE'

export const FETCH_STATIC_TEMPLATE_REQUEST =
  'shared/FETCH_STATIC_TEMPLATE_REQUEST'
export const FETCH_STATIC_TEMPLATE_SUCCESS =
  'shared/FETCH_STATIC_TEMPLATE_SUCCESS'
export const FETCH_STATIC_TEMPLATE_FAILURE =
  'shared/FETCH_STATIC_TEMPLATE_FAILURE'

export const ACCEPT_TERMS_OF_SERVICE_REQUEST =
  'shared/ACCEPT_TERMS_OF_SERVICE_REQUEST'
export const ACCEPT_TERMS_OF_SERVICE_SUCCESS =
  'shared/ACCEPT_TERMS_OF_SERVICE_SUCCESS'
export const ACCEPT_TERMS_OF_SERVICE_FAILURE =
  'shared/ACCEPT_TERMS_OF_SERVICE_FAILURE'

export const FETCH_MOBILE_TASK_TYPES_REQUEST =
  'shared/FETCH_MOBILE_TASK_TYPES_REQUEST'
export const FETCH_MOBILE_TASK_TYPES_SUCCESS =
  'shared/FETCH_MOBILE_TASK_TYPES_SUCCESS'
export const FETCH_MOBILE_TASK_TYPES_FAILURE =
  'shared/FETCH_MOBILE_TASK_TYPES_FAILURE'

export const FETCH_TEMPLATE_TYPES_REQUEST =
  'shared/FETCH_TEMPLATE_TYPES_REQUEST'
export const FETCH_TEMPLATE_TYPES_SUCCESS =
  'shared/FETCH_TEMPLATE_TYPES_SUCCESS'
export const FETCH_TEMPLATE_TYPES_FAILURE =
  'shared/FETCH_TEMPLATE_TYPES_FAILURE'

export const FETCH_AUDIT_LOG_TYPES_REQUEST =
  'shared/FETCH_AUDIT_LOG_TYPES_REQUEST'
export const FETCH_AUDIT_LOG_TYPES_SUCCESS =
  'shared/FETCH_AUDIT_LOG_TYPES_SUCCESS'
export const FETCH_AUDIT_LOG_TYPES_FAILURE =
  'shared/FETCH_AUDIT_LOG_TYPES_FAILURE'

export const FETCH_PROPERTY_TYPES_BY_CODE_REQUEST =
  'shared/FETCH_PROPERTY_TYPES_BY_CODE_REQUEST'
export const FETCH_PROPERTY_TYPES_BY_CODE_SUCCESS =
  'shared/FETCH_PROPERTY_TYPES_BY_CODE_SUCCESS'
export const FETCH_PROPERTY_TYPES_BY_CODE_FAILURE =
  'shared/FETCH_PROPERTY_TYPES_BY_CODE_FAILURE'

export const FETCH_LICENSE_TYPES_REQUEST = 'shared/FETCH_LICENSE_TYPES_REQUEST'
export const FETCH_LICENSE_TYPES_SUCCESS = 'shared/FETCH_LICENSE_TYPES_SUCCESS'
export const FETCH_LICENSE_TYPES_FAILURE = 'shared/FETCH_LICENSE_TYPES_FAILURE'

export const FETCH_POSTPROCESSOR_SLOT_TYPES_REQUEST =
  'shared/FETCH_POSTPROCESSOR_SLOT_TYPES_REQUEST'
export const FETCH_POSTPROCESSOR_SLOT_TYPES_SUCCESS =
  'shared/FETCH_POSTPROCESSOR_SLOT_TYPES_SUCCESS'
export const FETCH_POSTPROCESSOR_SLOT_TYPES_FAILURE =
  'shared/FETCH_POSTPROCESSOR_SLOT_TYPES_FAILURE'

export const FETCH_PROPERTY_TYPES_REQUEST =
  'shared/FETCH_PROPERTY_TYPES_REQUEST'
export const FETCH_PROPERTY_TYPES_SUCCESS =
  'shared/FETCH_PROPERTY_TYPES_SUCCESS'
export const FETCH_PROPERTY_TYPES_FAILURE =
  'shared/FETCH_PROPERTY_TYPES_FAILURE'

export const FETCH_DOCUMENT_TYPES_REQUEST =
  'shared/FETCH_DOCUMENT_TYPES_REQUEST'
export const FETCH_DOCUMENT_TYPES_SUCCESS =
  'shared/FETCH_DOCUMENT_TYPES_SUCCESS'
export const FETCH_DOCUMENT_TYPES_FAILURE =
  'shared/FETCH_DOCUMENT_TYPES_FAILURE'

export enum TableFilterType {
  Number = 'number',
  String = 'string',
  Date = 'date',
  Boolean = 'boolean',
}

export enum TableFilterMatching {
  Includes = 'INCLUDES',
  Is = 'IS',
  IsNot = 'IS_NOT',
  IsEmpty = 'IS_EMPTY',
  IsNotEmpty = 'IS_NOT_EMPTY',
  Equals = 'EQUALS',
  NotEquals = 'NOT_EQUALS',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN',
  Date = 'DATE',
}

export enum SearchType {
  PROPERTY_RDN = 'PROPERTY_RDN',
  LICENSE = 'LICENSE',
  PAYABLE = 'PAYABLE',
  PAYMENT = 'PAYMENT',
}
